var moduleMap = {
	"./styles": () => {
		return __webpack_require__.e(/* __federation_expose_styles */ "__federation_expose_styles").then(() => (() => ((__webpack_require__(58576)))));
	},
	"./Constants": () => {
		return Promise.all(/* __federation_expose_Constants */[__webpack_require__.e("vendors-node_modules_rxjs_dist_esm5_internal_operators_catchError_js-node_modules_rxjs_dist_e-5ab992"), __webpack_require__.e("vendors-node_modules_highcharts_modules_accessibility_js-node_modules_highcharts_modules_sank-fe3811"), __webpack_require__.e("webpack_sharing_consume_default_clsx_clsx-webpack_sharing_consume_default_date-fns_date-fns-w-518063"), __webpack_require__.e("webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("libs_sds_src_Components_index_ts"), __webpack_require__.e("apps_digital-asset-management_src_Constants_DxpCapabilities_constants_tsx"), __webpack_require__.e("__federation_expose_Constants")]).then(() => (() => ((__webpack_require__(67376)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};

__webpack_require__(4546)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});